import React from 'react';
import { Settings, Repeat, Wifi, CheckCircle2, Check } from 'lucide-react';
import { WEB_PHASES, WebPhase } from './types';

interface StepSidebarProps {
  /** The phase the current step belongs to. */
  activePhase: WebPhase;
}

const PHASE_ICONS: Record<WebPhase, React.ReactNode> = {
  hardware: <Settings size={16} />,
  registration: <Repeat size={16} />,
  wifi: <Wifi size={16} />,
  completion: <CheckCircle2 size={16} />,
};

const StepSidebar: React.FC<StepSidebarProps> = ({ activePhase }) => {
  const activeIdx = WEB_PHASES.findIndex((p) => p.key === activePhase);

  return (
    <ul className="dcfw-sidebar__list">
      {WEB_PHASES.map((phase, idx) => {
        const isDone = idx < activeIdx;
        const isActive = idx === activeIdx;
        const state = isActive ? 'is-active' : isDone ? 'is-done' : 'is-pending';
        return (
          <li key={phase.key} className={`dcfw-sidebar__item ${state}`}>
            <span className="dcfw-sidebar__icon">
              {isDone ? <Check size={16} /> : PHASE_ICONS[phase.key]}
            </span>
            <span className="dcfw-sidebar__label">{phase.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default StepSidebar;
